// Navheader.jsx - version corrigée
import { Link } from "react-router-dom";

const Navheader = () => {
    return (
        <>
            <div className="nav-header bg-white">
                <Link 
                    to="" 
                    className="d-flex align-items-center justify-content-center text-decoration-none w-100"
                    style={{
                        height: "120px",
                        padding: "10px 0"
                    }}
                >
                    {/* Logo pour desktop */}
                <img
                    className="logo-abbr d-lg-block d-md-block d-sm-none d-none"
                    src="https://cdn.prod.website-files.com/68063d6193c1f009cf1fdccd/6806b7b5df7ca03c524c1008_Projet%20Studio%20(1).png"
                    alt="TradeVault Logo"
                    style={{
                        display: "block",
                        maxWidth: "100%",
                        height: "95px",
                        borderRadius: "3px",
                        objectFit: "contain",
                        margin: "0 auto",
                        flexShrink: 0,
                    }}
                />
                </Link>
            </div>
        </> 
    );                             
};

export default Navheader;